import UserListCard from "./UserListCard";

export default UserListCard;